import { Icon, SvgBack5 } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';

import { skipBack } from 'creators/videoPlayer';

import ControlBarButton from '../control-bar-button';

import './styles.less';

export default function StepBackFiveButton(props) {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(skipBack());
  };

  return (
    <ControlBarButton
      className={classNames('step-back-five-button', {
        'crowded-embed': props.crowded && !props.isMainVideoOnSharePage,
      })}
      hoverTagText="Step Back (j)"
      seeking={props.seeking}
      onClick={handleClick}
    >
      <Icon
        color="white"
        className="control-bar-button-icon"
        icon={<SvgBack5 />}
      />
    </ControlBarButton>
  );
}
